import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Triplist from "../../../assets/images/triplist.svg";
import B2Cicon from "../../../assets/images/icons8-customer-90.png";
import B2Bicon from "../../../assets/images/icons8-b2b-90.png";
import ETSicon from "../../../assets/images/icons8-enterprise-90.png";
import GT from "../../../assets/images/gt.svg";
import Notify from "../../../assets/images/notify.svg";
import Manage from "../../../assets/images/manage.svg";
import Dashboard from "../../../assets/images/icons8-dashboard-90.png";
import Price from "../../../assets/images/price.svg";
import User from "../../../assets/images/icons8-users-90.png";
import Pricing from "../../../assets/images/icons8-borrow-book-90.png";
import Gen from "../../../assets/images/icons8-general-90.png";
import Alert from "../../../assets/images/alert.svg";
import Settings from "../../../assets/images/setting.svg";
import Vendor from "../../../assets/images/icons8-vendor-90.png";
import Tmc from "../../../assets/images/icons8-company-90.png";
import NewBook from "../../../assets/images/icons8-order-90.png";
import Cab from "../../../assets/images/icons8-vehicle-90.png";
import VehType from "../../../assets/images/icons8-different-90.png";
import AggregatorIcon from "../../../assets/images/icons8-feedly-90.png";
import Distance from "../../../assets/images/distance.svg";
import Time from "../../../assets/images/time.svg";
import Calender from "../../../assets/images/calender.svg";
import Geo from "../../../assets/images/geofence.svg";
import Air from "../../../assets/images/icons8-airport-90.png";
import Fixed from "../../../assets/images/icons8-price-tag-90.png";
import Route from "../../../assets/images/icons8-route-90.png";
import Area from "../../../assets/images/icons8-tv-area-90.png";
import Geofill from "../../../assets/images/icons8-geometry-90.png";
import Tracking from "../../../assets/images/icons8-tracking-90.png";
import Groups from "../../../assets/images/groups.svg";
import Driver from "../../../assets/images/icons8-driver-90.png";
import Operator from "../../../assets/images/icons8-operator-90.png";
import Admin from "../../../assets/images/icons8-administrator-male-90.png";
import Support from "../../../assets/images/icons8-customer-support-90.png";
import Corp from "../../../assets/images/icons8-corp-90.png";
import Branch from "../../../assets/images/icons8-branch-90.png";
import ProductUser from "../../../assets/images/product-user.svg";
import Enterprice from "../../../assets/images/icons8-corporate-90 (1).png";
import Rep from "../../../assets/images/icons8-report-90.png";
import Bill from "../../../assets/images/icons8-general-ledger-90.png";
import TripIcon from "../../../assets/images/trip-sheet1.png";
import STMT from "../../../assets/images/statement.svg";
import Offer from "../../../assets/images/icons8-offer-90.png";
import Coupon from "../../../assets/images/icons8-discount-90.png";
import Promo from "../../../assets/images/icons8-pin-code-90.png";
import HotRoute from "../../../assets/images/hotRoute.svg";
import Setting from "../../../assets/images/setting.svg";
import "./sidebar.scss";
import { sidebarToggleItems } from "../../../utility/constants";
class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
  }

  toggleMenuItem = (type) => (e) => {
    e.stopPropagation(); // stop propagation to avoid parrent toggle
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR_MENU",
      payload: {
        ...sidebarToggleItems,
        users:
          type === "drivers" ||
          type === "taxidaUsers" ||
          type === "operators" ||
          type === "vehicles" ||
          type === "b2b" ||
          type === "enterprise" ||
          type === "tmc" ||
          type === "vendor" ||
          type === "ota",
        [type]: !this.props.toggleItems[type],
      },
    });
  };

  mobToggleSidebar = () => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (mobile.matches) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true },
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (e) => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (
      mobile.matches &&
      this.wrapperRef &&
      !this.wrapperRef.contains(e.target)
    ) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true },
      });
    }
  };

  render() {
    const userRole = this.authUser.roleId || 0;
    const {
      sidebar: { visible: isOpen },
      toggleItems,
    } = this.props;
    return (
      <div
        ref={this.setWrapperRef}
        className={isOpen ? "sidebar" : "sidebar open"}
      >
        <nav className="side-nav">
          <ul className="nav-list">
            <li className="list-items">
              {(userRole === 1 || userRole === 3) && (
                <NavLink
                  onClick={this.mobToggleSidebar}
                  tabIndex="1"
                  to="/dashboard"
                >
                  <img src={Dashboard} alt="dashboard" className="img-fill" />
                  <span>Dashboard</span>
                </NavLink>
              )}
            </li>
            <li className="list-items">
              {(userRole === 1 || userRole === 3) && (
                <NavLink
                  onClick={this.mobToggleSidebar}
                  tabIndex="1"
                  to="/analytics-dashboard-v2"
                >
                  <img src={Dashboard} alt="" className="img-fill" />
                  <span>Analytics Dashboard V2</span>
                </NavLink>
              )}
            </li>
            <li
              className="list-items"
              onClick={this.toggleMenuItem("bookings")}
            >
              <button type="button" tabIndex="1">
                <img src={NewBook} alt="newBook" className="img-fill" />
                <span>Bookings</span>
                <i
                  className={
                    toggleItems.bookings ? "chevron down" : "chevron right"
                  }
                />
              </button>
              <ul
                className={
                  toggleItems.bookings
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/all-trips"
                  >
                    <img src={B2Bicon} alt="triplist" />
                    <span>All Trips</span>
                  </NavLink>
                </li>
                {/* <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/trips"
                  >
                    <img src={B2Cicon} alt="triplist" />
                    <span>B2C Trip list</span>
                  </NavLink>
                </li> */}
                {/* <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/b2btrips"
                  >
                    <img src={B2Bicon} alt="triplist" />
                    <span>B2B Trip list</span>
                  </NavLink>
                </li> */}
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/etstrips"
                  >
                    <img src={ETSicon} alt="triplist" />
                    <span>ETS Trip list</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/savaari"
                  >
                    <img src={ETSicon} alt="triplist" />
                    <span>Savaari</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/demand-partners"
                  >
                    <img src={ETSicon} alt="API Partners transactions" />
                    <span>API Partners transactions</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/broadcast-fulfilment"
                  >
                    <img src={ETSicon} alt="Broadcast fulfilment" />
                    <span>Broadcast fulfilment</span>
                  </NavLink>
                </li>
                 {/* <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/refex-audits"
                  >
                    <img src={ETSicon} alt="refex audits" />
                    <span>Refex Audits</span>
                  </NavLink>
                </li> */}
              </ul>
            </li>
            {/* <li className="list-items" onClick={this.toggleMenuItem("aari")}>
              <button type="button" tabIndex="1">
                <img src={NewBook} alt="newBook" className="img-fill" />
                <span>AARI</span>
                <i
                  className={
                    toggleItems.aari ? "chevron down" : "chevron right"
                  }
                />
              </button>
              <ul
                className={
                  toggleItems.aari
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/aari/conversation"
                  >
                    <img src={B2Bicon} alt="triplist" />
                    <span>Conversation</span>
                  </NavLink>
                </li>
              </ul>
            </li> */}
            <li
              className="list-items"
              onClick={this.toggleMenuItem("operatorTrips")}
            >
              {userRole === 10 && (
                <button type="button" tabIndex="1">
                  <img src={NewBook} alt="newBook" />
                  <span>Operator trips</span>
                  <i
                    className={
                      toggleItems.operatorTrips
                        ? "chevron down"
                        : "chevron right"
                    }
                  />
                </button>
              )}
              <ul
                className={
                  toggleItems.operatorTrips
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/bid-list"
                  >
                    <img src={GT} alt="gt" />
                    <span>Bid list</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/accepted-trips"
                  >
                    <img src={Triplist} alt="triplist" />
                    <span>Accepted trips</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            {/* <li className="list-items">
              <NavLink
                tabIndex="1"
                to="/driver-tracking"
                onClick={this.mobToggleSidebar}
              >
                <img src={Tracking} alt="locations" className="img-fill" />
                <span>Driver tracking</span>
              </NavLink>
            </li> */}
            <li className="list-items">
              {userRole === 1 && (
                <NavLink
                  onClick={this.mobToggleSidebar}
                  tabIndex="1"
                  to="/notification"
                >
                  <img src={Notify} alt="dashboard" className="img-fill" />
                  <span>Notification</span>
                </NavLink>
              )}
            </li>{" "}
            {(userRole === 1 || userRole === 3) && (
              <li className="list-items" onClick={this.toggleMenuItem("users")}>
                <button type="button" tabIndex="1">
                  <img src={User} alt="users" className="img-fill" />
                  <span>User</span>
                  <i
                    className={
                      toggleItems.users ? "chevron down" : "chevron right"
                    }
                  />
                </button>

                <ul
                  className={
                    toggleItems.users
                      ? "list-item-nav responsive"
                      : "list-item-nav"
                  }
                  onClick={(e) => e.stopPropagation()}
                >
                  {/*{userRole === 1 && (
                <li
                  className="list-items list-bl"
                  onClick={this.toggleMenuItem("operators")}
                >
                  <button type="button" className="bl-pad" tabIndex="1">
                    <img src={Operator} alt="operator" />
                    <span>Operator</span>
                    <i
                      className={
                        toggleItems.operators
                          ? "chevron down"
                          : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.operators
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    <li className="list-items list-sub">
                      <NavLink
                        className="sub-pad"
                        tabIndex="1"
                        to="/users/operators/operator"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Operator} alt="operators" />
                        <span>Operator</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-sub">
                      <NavLink
                        className="sub-pad"
                        tabIndex="1"
                        to="/users/operators/groups"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Groups} alt="groups" />
                        <span>Operator group</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                  )} */}

                  <React.Fragment>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/users/drivers/corporate-driver"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Driver} alt="drivers" />
                        <span>Driver</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-sub">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/users/corporate-vehicle"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Cab} alt="Cab" />
                        <span>Vehicle</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-sub">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/users/operators/operator"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Operator} alt="operators" />
                        <span>Operator(B2C)</span>
                      </NavLink>
                    </li>
                    {/*<li className="list-items list-sub">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/operator"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Operator} alt="operators" />
                        <span>Operator</span>
                      </NavLink>
                    </li>*/}
                    {/*<li className="list-items list-bl">
                    {userRole === 1 && (
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/corporate"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Settings} alt="settings" />
                        <span>Corporate</span>
                      </NavLink>
                    )}
                    </li>*/}
                    {/* <li
                    className="list-items list-bl"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <NavLink
                      className="bl-pad"
                      tabIndex="1"
                      to="/users/business-user"
                      onClick={this.mobToggleSidebar}
                    >
                      <img src={Admin} alt="business-user" />
                      <span>Business Partner</span>
                    </NavLink>
                    </li> */}
                    <li className="list-items list-bl">
                      {(userRole === 1 || userRole === 3) && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/vendor"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={Vendor} alt="settings" />
                          <span>Vendors(B2B-V)</span>
                        </NavLink>
                      )}
                    </li>
                    <li className="list-items list-bl">
                      {(userRole === 1 || userRole === 3) && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/tmc"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={Tmc} alt="settings" />
                          <span>TMC(B2B-T)</span>
                        </NavLink>
                      )}
                    </li>
                    <li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/aggregator"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={AggregatorIcon} alt="settings" />
                          <span>OTA(B2B-A)</span>
                        </NavLink>
                      )}
                    </li>
                     <li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/supplier"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={Vendor} alt="settings" />
                          <span>Supplier</span>
                        </NavLink>
                      )}
                    </li>
                    <li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/partners"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={Tmc} alt="partners" />
                          <span>API partners</span>
                        </NavLink>
                      )}
                    </li>
                    {/*<li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/agg"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={AggregatorIcon} alt="settings" />
                          <span>Aggregator</span>
                        </NavLink>
                      )}
                    </li>*/}
                    {(userRole === 1 || userRole === 3) && (
                      <li
                        className="list-items list-bl"
                        onClick={this.toggleMenuItem("b2b")}
                      >
                        <button type="button" className="bl-pad" tabIndex="1">
                          <img src={Enterprice} alt="taxida-user" />
                          <span>Enterprise(B2B-E)</span>
                          <i
                            className={
                              toggleItems.b2b ? "chevron down" : "chevron right"
                            }
                          />
                        </button>
                        <ul
                          className={
                            toggleItems.b2b
                              ? "list-item-nav responsive"
                              : "list-item-nav"
                          }
                          onClick={(e) => e.stopPropagation()}
                        >
                          <li className="list-items list-sub">
                            <NavLink
                              className="sub-pad"
                              tabIndex="1"
                              to="/corporate-new"
                              onClick={this.mobToggleSidebar}
                            >
                              <img src={Corp} alt="admin" />
                              <span>Corporate</span>
                            </NavLink>
                          </li>
                          <li className="list-items list-sub">
                            <NavLink
                              className="sub-pad"
                              tabIndex="1"
                              to="/branch-managers"
                              onClick={this.mobToggleSidebar}
                            >
                              <img src={Branch} alt="admin" />
                              <span>Branch Manager</span>
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                    )}
                    {userRole === 1 && (
                      <li
                        className="list-items list-bl"
                        onClick={this.toggleMenuItem("taxidaUsers")}
                      >
                        <button type="button" className="bl-pad" tabIndex="1">
                          <img src={ProductUser} alt="taxida-user" />
                          <span>Taxida user</span>
                          <i
                            className={
                              toggleItems.taxidaUsers
                                ? "chevron down"
                                : "chevron right"
                            }
                          />
                        </button>
                        <ul
                          className={
                            toggleItems.taxidaUsers
                              ? "list-item-nav responsive"
                              : "list-item-nav"
                          }
                          onClick={(e) => e.stopPropagation()}
                        >
                          <li className="list-items list-sub">
                            <NavLink
                              className="sub-pad"
                              tabIndex="1"
                              to="/users/admins"
                              onClick={this.mobToggleSidebar}
                            >
                              <img src={Admin} alt="admin" />
                              <span>Admin</span>
                            </NavLink>
                          </li>
                          <li className="list-items list-sub">
                            <NavLink
                              className="sub-pad"
                              tabIndex="1"
                              to="/users/controllers"
                              onClick={this.mobToggleSidebar}
                            >
                              <img src={Support} alt="admin" />
                              <span>Controller</span>
                            </NavLink>
                          </li>

                          {/* <li
                      className="list-items list-bl"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/users/customers"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Manage} alt="manage" />
                        <span>Customer</span>
                      </NavLink>
                    </li> */}
                        </ul>
                      </li>
                    )}

                    <li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/users/device"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={AggregatorIcon} alt="settings" />
                          <span>All devices</span>
                        </NavLink>
                      )}
                    </li>

                    {/* <li className="list-items list-bl">
                      {userRole === 1 && (
                        <NavLink
                          className="bl-pad"
                          tabIndex="1"
                          to="/user"
                          onClick={this.mobToggleSidebar}
                        >
                          <img src={ProductUser} alt="taxida-user" />
                          <span>User</span>
                        </NavLink>
                      )}
                    </li> */}
                  </React.Fragment>
                </ul>
              </li>
            )}
            {/*<li
              className="list-items"
              onClick={this.toggleMenuItem("pricings")}
            >
              <button type="button" tabIndex="1">
                <img src={NewBook} alt="newBook" className="img-fill" />
                <span>Pricings</span>
                <i
                  className={
                    toggleItems.pricings ? "chevron down" : "chevron right"
                  }
                />
              </button>
              <ul
                className={
                  toggleItems.pricings
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    className="bl-pad"
                    to="/pricings/ota"
                  >
                    <img src={B2Cicon} alt="triplist" />
                    <span>OTA</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="list-items" onClick={this.toggleMenuItem("fare")}>
              {userRole === 1 && (
                <button type="button" tabIndex="1">
                  <img src={Price} alt="price" />
                  <span>Fare</span>
                  <i
                    className={
                      toggleItems.fare ? "chevron down" : "chevron right"
                    }
                  />
                </button>
              )}
              <ul
                className={
                  toggleItems.fare
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/fares/distance"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Distance} alt="distance" />
                    <span>Distance</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/fares/geofence"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Geo} alt="geofence" />
                    <span>Geofence</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/fares/time"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Time} alt="time" />
                    <span>Peak hours</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/fares/calender"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Calender} alt="calender" />
                    <span>Calender</span>
                  </NavLink>
                </li>
              </ul>
              </li>*/}
            <li
              className="list-items"
              onClick={this.toggleMenuItem("geofence")}
            >
              {userRole === 1 && (
                <>
                  <button type="button" tabIndex="1">
                    <img src={Geofill} alt="locations" className="img-fill" />
                    <span>Geofence</span>
                    <i
                      className={
                        toggleItems.geofence ? "chevron down" : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.geofence
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/fares/hot-routes"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={HotRoute} alt="locations" />
                        <span>Hot routes</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/fares/geofence"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Air} alt="locations" />
                        <span>Airports & hills</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/fares/fixed-fare"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Fixed} alt="geofence" />
                        <span>Fixed fare</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/route-based-fare"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Route} alt="geofence" />
                        <span>Route based fare</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/fares/operating-area"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Area} alt="geofence" />
                        <span>Operating area(B2C)</span>
                      </NavLink>
                    </li>
                    {/*<li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        tabIndex="1"
                        to="/fares/operate-area"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Area} alt="geofence" />
                        <span>Operating area</span>
                      </NavLink>
                    </li>*/}
                  </ul>
                </>
              )}
            </li>
            {/*<li className="list-items" onClick={this.toggleMenuItem("ondc")}>
              <button type="button" tabIndex="1">
                <img src={ProductUser} alt="ondc" />
                <span>Taxida regions</span>
                <p className="side-mr">inventory</p>
                <i
                  className={
                    toggleItems.ondc ? "chevron down" : "chevron right"
                  }
                />
              </button>
              <ul
                className={
                  toggleItems.ondc
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/ondc/pricing"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Settings} alt="pricin" />
                    <span>Region</span>
                  </NavLink>
                </li>
              </ul>
              </li>*/}
            <li className="list-items" onClick={this.toggleMenuItem("offers")}>
              {userRole === 1 && (
                <button type="button" tabIndex="1">
                  <img src={Offer} alt="offer" className="img-fill" />
                  <span>Loyalties & Offers</span>
                  <i
                    className={
                      toggleItems.offers ? "chevron down" : "chevron right"
                    }
                  />
                </button>
              )}
              <ul
                className={
                  toggleItems.offers
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/promo-codes"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Promo} alt="coupon" />
                    <span>Promo code</span>
                  </NavLink>
                </li>
                <li className="list-items list-bl">
                  <NavLink
                    className="bl-pad"
                    tabIndex="1"
                    to="/operator-discount"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={Coupon} alt="coupon" />
                    <span>Operator discount</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            {/*<li className="list-items">
              {userRole === 1 && (
                <NavLink
                  tabIndex="1"
                  to="/locations"
                  onClick={this.mobToggleSidebar}
                >
                  <img src={Geo} alt="locations" />
                  <span>Locations</span>
                </NavLink>
              )}
              </li>*/}
            {/*<li className="list-items">
              {userRole === 1 && (
                <NavLink
                  tabIndex="1"
                  to="/commissions"
                  onClick={this.mobToggleSidebar}
                >
                  <img src={Pricing} alt="price" />
                  <span>Commission</span>
                </NavLink>
              )}
              </li>*/}
            {/*<li className="list-items">
              {userRole === 1 && (
                <NavLink
                  tabIndex="1"
                  to="/driver-registration"
                  onClick={this.mobToggleSidebar}
                >
                  <img src={Cab} alt="driver" />
                  <span>Driver registration</span>
                </NavLink>
              )}
              </li>*/}
            {/* <li className="list-items">
              <NavLink tabIndex="1" to="/under-construction">
                <img src={Note} alt="note" />
                <span>Vehicle management</span>
              </NavLink>
            </li> */}
            {/*<li className="list-items" onClick={this.toggleMenuItem("invoice")}>
              {userRole === 1 && (
                <button type="button" tabIndex="1">
                  <img src={Bill} alt="bill" />
                  <span>Statement & invoice</span>
                  <i
                    className={
                      toggleItems.invoice ? "chevron down" : "chevron right"
                    }
                  />
                </button>
              )}
              <ul
                className={
                  toggleItems.invoice
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    to="/statements"
                    type="button"
                    className="bl-pad"
                    tabIndex="1"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={STMT} alt="statement" />
                    <span>Operator statements</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="list-items" onClick={this.toggleMenuItem("aucto")}>
              {userRole === 1 && (
                <button type="button" tabIndex="1">
                  <img src={Bill} alt="bill" />
                  <span>AUCTO</span>
                  <i
                    className={
                      toggleItems.aucto ? "chevron down" : "chevron right"
                    }
                  />
                </button>
              )}
              <ul
                className={
                  toggleItems.aucto
                    ? "list-item-nav responsive"
                    : "list-item-nav"
                }
                onClick={(e) => e.stopPropagation()}
              >
                <li className="list-items list-bl">
                  <NavLink
                    to="/aucto-config"
                    type="button"
                    className="bl-pad"
                    tabIndex="1"
                    onClick={this.mobToggleSidebar}
                  >
                    <img src={STMT} alt="AUCTO" />
                    <span>AUCTO config</span>
                  </NavLink>
                </li>
              </ul>
              </li>
            <li className="list-items">
              {userRole === 1 && (
                <NavLink
                  tabIndex="1"
                  to="/driver-alerts"
                  onClick={this.mobToggleSidebar}
                >
                  <img src={Alert} alt="price" />
                  <span>Driver alert</span>
                </NavLink>
              )}
            </li>*/}
            {/*<li className="list-items">
              {userRole === 1 && (
                <NavLink
                  tabIndex="1"
                  to="/taxida-quotes"
                  onClick={this.mobToggleSidebar}
                >
                  <img src={Pricing} alt="taxidaQuote" />
                  <span>Taxida Quote</span>
                </NavLink>
              )}
              </li>*/}
            <li className="list-items" onClick={this.toggleMenuItem("reports")}>
              {userRole === 1 && (
                <>
                  <button type="button" tabIndex="1">
                    <img src={Rep} alt="report" className="img-fill" />
                    <span>Statements</span>
                    <i
                      className={
                        toggleItems.reports ? "chevron down" : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.reports
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/reports"
                      >
                        <img src={Bill} alt="report" />
                        <span>Reports</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/statements/savaari-analytics"
                      >
                        <img src={Bill} alt="report" />
                        <span>Savaari Analytics</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/tripsheet"
                      >
                        <img src={TripIcon} alt="report" />
                        <span>Trip sheet</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/uploadcenter"
                      >
                        <img src={TripIcon} alt="report" />
                        <span>Upload center</span>
                      </NavLink>
                    </li>
                  </ul>
                </>
              )}
            </li>
            <li
              className="list-items"
              onClick={this.toggleMenuItem("siteSettings")}
            >
              {userRole === 1 && (
                <>
                  <button type="button" tabIndex="1">
                    <img src={Settings} alt="settings" className="img-fill" />
                    <span>Site settings</span>
                    <i
                      className={
                        toggleItems.siteSettings
                          ? "chevron down"
                          : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.siteSettings
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        to="/site-settings"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Gen} alt="settings" />
                        <span>General config</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        to="/vehicle-types"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={VehType} alt="vehicle" />
                        <span>Vehicle type</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        to="/taxida-commission"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Pricing} alt="commission" />
                        <span>Taxida commission</span>
                      </NavLink>
                    </li>
                     <li className="list-items list-bl">
                      <NavLink
                        className="bl-pad"
                        to="/price-surge"
                        onClick={this.mobToggleSidebar}
                      >
                        <img src={Pricing} alt="surge" />
                        <span>Price Engine Surge</span>
                      </NavLink>
                    </li>
                  </ul>
                </>
              )}
            </li>
            {/* <li className="list-items">
              <button type="button" tabIndex="1">
                <img src={Widget} alt="price" />
                <span>Settings</span>
              </button>
            </li>
            <li className="list-items">
              <NavLink tabIndex="1" to="/customers">
                <img src={Widget} alt="price" />
                <span>Sample page</span>
              </NavLink>
            </li> */}
          </ul>
        </nav>
      </div>
    );
  }
}
export default connect((state) => {
  return {
    sidebar: state.sidebar,
    toggleItems: state.sidebarMenuToggle,
  };
})(Sidebar);
